
import { PRODUCT_IMAGES } from '/src/v4/product-images.js';

const products = [
  ['Aurora hoodie',          'Apparel',       49, 65,  'Sale',     'red',    '★★★★☆ 4.6 (128)', 'hoodie'],
  ['Linen field shirt',      'Apparel',       89, null,'New',      'green',  '★★★★★ 4.9 (42)',  'shirt'],
  ['Trail runner sneakers',  'Footwear',      129,159, 'Sale',     'red',    '★★★★☆ 4.4 (231)', 'sneakers'],
  ['Canvas weekend bag',     'Accessories',   79, null,null,       null,     '★★★★☆ 4.5 (76)',  'bag'],
  ['Wireless earbuds Pro',   'Electronics',   149,null,'Hot',      'yellow', '★★★★★ 5.0 (892)', 'earbuds'],
  ['Ceramic pour-over set',  'Home',          54, null,null,       null,     '★★★★☆ 4.7 (61)',  'pourover'],
  ['Standing desk mat',      'Home',          39, 49,  'Sale',     'red',    '★★★★☆ 4.3 (158)', 'mat'],
  ['Mechanical keyboard',    'Electronics',   189,null,'New',      'green',  '★★★★★ 4.8 (304)', 'keyboard'],
  ['Merino base layer',      'Apparel',       69, null,null,       null,     '★★★★☆ 4.6 (97)',  'baselayer']
];

document.getElementById('products-grid').innerHTML = products.map(([name, cat, price, oldPrice, badge, badgeCls, stars, slug]) => `
  <a class="product-card" href="product_detail.html">
    <div class="product-thumb">
      ${badge ? `<span class="product-badge"><span class="chip chip-${badgeCls}">${badge}</span></span>` : ''}
      ${PRODUCT_IMAGES[slug] || ''}
    </div>
    <div class="product-info">
      <div class="name">${name}</div>
      <div class="category">${cat}</div>
      <div class="price-row">
        <span class="price">$${price}</span>
        ${oldPrice ? `<span class="price-old">$${oldPrice}</span>` : ''}
      </div>
      <div class="stars">${stars}</div>
    </div>
  </a>
`).join('');
